(function () {
  var footer = document.querySelector('footer');
  if (!footer) return;
  var mq = window.matchMedia('(max-width: 749px)');
  var blocks = [].slice.call(footer.querySelectorAll('.footer-block'));

  function parts(block) {
    return {
      heading: block.querySelector('.footer-block__heading'),
      content: block.querySelector('.footer-block__details-content')
    };
  }

  function setOpen(block, open) {
    var p = parts(block);
    block.classList.toggle('is-open', open);
    if (p.heading) p.heading.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function apply() {
    footer.classList.toggle('is-accordion', mq.matches);
    blocks.forEach(function (block, i) {
      var p = parts(block);
      if (!p.heading || !p.content) return;
      if (mq.matches) {
        p.content.id = p.content.id || 'footer-panel-' + i;
        p.heading.setAttribute('role', 'button');
        p.heading.setAttribute('tabindex', '0');
        p.heading.setAttribute('aria-controls', p.content.id);
        setOpen(block, block.classList.contains('is-open'));
      } else {
        p.heading.removeAttribute('role');
        p.heading.removeAttribute('tabindex');
        p.heading.removeAttribute('aria-controls');
        p.heading.removeAttribute('aria-expanded');
        block.classList.remove('is-open');
      }
    });
  }

  blocks.forEach(function (block) {
    var p = parts(block);
    if (!p.heading || !p.content) return;
    function toggle() {
      if (!mq.matches) return;
      setOpen(block, !block.classList.contains('is-open'));
    }
    p.heading.addEventListener('click', toggle);
    p.heading.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  });

  apply();
  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);
})();
